import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";

export default function CtaBlock() {
  return (
    <section className="bg-ink text-bone grain relative" data-testid="cta-block">
      <div className="max-w-[1240px] mx-auto px-6 md:px-10 lg:px-14 py-24 md:py-32 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-3">
            <div className="text-[11px] tracking-widest uppercase font-mono text-earth">Engagement</div>
          </div>
          <div className="md:col-span-9">
            <h2 className="display-2 text-4xl md:text-5xl lg:text-6xl text-bone max-w-4xl">
              We accept a small number of mandates each year. Let us understand the question first.
            </h2>

            <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-8 max-w-3xl">
              <a
                href="mailto:mandates@dugavuventures.com"
                data-testid="cta-discuss-mandate"
                className="group inline-flex items-start justify-between gap-6 bg-oxblood text-white px-7 py-6 hover:bg-oxblood-hover transition-colors duration-300"
              >
                <div>
                  <div className="text-[11px] tracking-widest uppercase font-mono opacity-70">Primary</div>
                  <div className="font-serif text-2xl mt-1">Discuss a mandate</div>
                </div>
                <ArrowUpRight size={20} weight="thin" className="mt-1 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </a>
              <a
                href="mailto:rfp@dugavuventures.com"
                data-testid="cta-capability-statement"
                className="group inline-flex items-start justify-between gap-6 border border-bone/30 text-bone px-7 py-6 hover:border-earth hover:text-earth transition-colors duration-300"
              >
                <div>
                  <div className="text-[11px] tracking-widest uppercase font-mono opacity-70">Procurement</div>
                  <div className="font-serif text-2xl mt-1">Request a capability statement</div>
                </div>
                <ArrowUpRight size={20} weight="thin" className="mt-1 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </a>
            </div>

            <div className="mt-10 text-[14px] text-bone/65 max-w-2xl">
              Procurement enquiries are also welcome via{" "}
              <Link to="/contact" className="link-underline text-bone" data-testid="cta-contact-link">our contact page</Link>.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
